import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X, Home, Info, BookOpen, ArrowRight, FileText } from 'lucide-react';

const links = [
  { label:'Home',               to:'/',       icon:<Home size={16}/> },
  { label:'About',              to:'/about',  icon:<Info size={16}/> },
  { label:'Wholesale',            to:'/catalog',icon:<BookOpen size={16}/> },
];

const techLinks = [
  { label:'Warranty',                  to:'/technical/warranty' },
  { label:'Technical Data Sheet',      to:'/technical/data-sheet' },
  { label:'Installation Instructions', to:'/technical/installation-instructions' },
];

export default function Drawer({ open, onClose }) {
  const location = useLocation();
  if (!open) return null;
  return (
    <>
      <div className="drawer-overlay" onClick={onClose} role="presentation"/>
      <aside className="fixed top-0 left-0 h-full w-72 bg-white z-50 flex flex-col animate-slide-in-left shadow-2xl" role="dialog" aria-label="Navigation drawer">
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <button onClick={onClose} className="text-charcoal hover:text-gold transition-colors p-1 ml-auto" aria-label="Close drawer"><X size={20}/></button>
        </div>
        <nav className="flex-1 px-6 py-8">
          <ul className="space-y-1">
            {links.map(link=>(
              <li key={link.to}>
                <Link to={link.to} onClick={onClose} className={`flex items-center justify-between group px-3 py-3 rounded transition-colors duration-200 ${location.pathname===link.to?'bg-cream-100 text-gold':'text-charcoal hover:bg-cream-50 hover:text-gold'}`}>
                  <span className="flex items-center gap-3 font-sans text-sm tracking-wider uppercase">{link.icon}{link.label}</span>
                  <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity"/>
                </Link>
              </li>
            ))}
          </ul>
          <div style={{ marginTop: 24, borderTop: '1px solid #f0ece4', paddingTop: 20 }}>
            <p style={{ fontFamily: 'var(--sans)', fontSize: 10, letterSpacing: '.18em', textTransform: 'uppercase', color: 'var(--ash)', marginBottom: 10 }}>Technical Documents</p>
            <ul className="space-y-1">
              {techLinks.map(link=>(
                <li key={link.to}>
                  <Link to={link.to} onClick={onClose} className={`flex items-center justify-between group px-3 py-2 rounded transition-colors duration-200 ${location.pathname===link.to?'bg-cream-100 text-gold':'text-charcoal hover:bg-cream-50 hover:text-gold'}`}>
                    <span className="flex items-center gap-3 font-sans text-sm tracking-wider uppercase"><FileText size={14}/>{link.label}</span>
                    <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity"/>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
        <div className="px-6 py-6 border-t border-gray-100">
          <p className="font-sans text-xs text-gray-400 mt-1">Info@contractorrob.com</p>
        </div>
      </aside>
    </>
  );
}
